<script>
import materialOption from './material-option'
import store from '../store'
import configure from '../tools/configurator/configure'

export default {
  name: 'statesList',
  components: {
    materialOption
  },
  computed: {
    states () {
      let state = store.getters['statesList/getState']
      return state.states
    }
  },
  methods: {
    setState (state) {
      if (state.basedon !== undefined) {
        this.setState(state.basedon)
      }

      if (state.material !== undefined) {
        for (let item of state.material) {
          let materialGroup = store.getters['materialList/getMaterialByProperty']('name', item.name)
          let mtlOption = materialGroup.options.find(m => m.title === item.option)
          materialOption.methods.setMaterial(materialGroup, mtlOption)
        }
      }

      if (state.visibility !== undefined) {
        for (let item of state.visibility) {
          store.commit('visibilitySingleList/setVisibility', {optionName: item.name, switch: item.option})
          let visOption = store.getters['visibilitySingleList/getItemByName'](item.name)
          if (visOption === undefined) {
            console.log('An option doesn\'t exist:', item.name)
          } else {
            configure.SetVisibilitySingle(item.option, visOption.objects, true)
          }
        }
      }

      if (state.visibilityoptionsgroup !== undefined) {
        for (let item of state.visibilityoptionsgroup) {
          store.commit('visibilityGroupList/updateTitle', {groupname: item.name, pickedOption: item.option})
          let visGroup = store.getters['visibilityGroupList/getItemByName'](item.name)
          if (visGroup === undefined) {
            console.log('A group doesn\'t exist:', item.name)
          } else {
            let visOption = visGroup.options.find(o => o.name === item.option)
            if (visOption === undefined) {
              console.log('An option doesn\'t exist:', item.name)
            } else {
              configure.SetVisibilityGroup(visGroup, visOption)
            }
          }
        }
      }
    }
  }
}
</script>

<template>
<div class="states-list">
  <md-list-item v-for="(state, index) in states" :key="index" @click="setState(state)">
    {{state.title}}
  </md-list-item>
</div>
</template>

<style lang="scss" scoped>
</style>
